<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <b-modal
        centered
        :hide-footer="true"
        size="xl"
        title="Inputs"
        id="modal-1">

      <form-stock
          :logType="'group'"
          :itemId="this.$route.params.groupid"></form-stock>


      <template v-if="logsInput.length > 0">
        <h4 class="font-weight-bold">Filter</h4>

        <div>
          <b-row>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="DATE FROM">
                <date-picker
                    popover
                    format="YYYY-MM-DD"
                    display-format="YYYY-MM-DD"
                    v-model="filters.filterDate.fromDate"
                    @change="onSelectFilter"
                    locale="en"></date-picker>

                <a v-if="filters.filterDate.fromDate != null || filters.filterDate.toDate != null"
                   @click.prevent="clearDatesForm"
                   href="#" class="text-danger d-block">clear dates</a>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="DATE TO">
                <date-picker
                    popover
                    format="YYYY-MM-DD"
                    display-format="YYYY-MM-DD"
                    v-model="filters.filterDate.toDate"
                    @change="onSelectFilter"
                    locale="en"></date-picker>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="PRINT">
                <b-button @click="printInput" variant="danger">{{ $t('printTitle') }}</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>


        <div class="table-responsive">
          <log-items id="printInput" :items="logsInput"></log-items>
        </div>
      </template>

    </b-modal>
    <!--END Inputs-->

    <b-modal
        centered
        :hide-footer="true"
        size="xl"
        title="Outputs"
        id="modal-2">

      <template v-if="logsOutput.length > 0">
        <h4 class="font-weight-bold">Filter</h4>

        <div>
          <b-row>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="DATE FROM">
                <date-picker
                    popover
                    format="YYYY-MM-DD"
                    display-format="YYYY-MM-DD"
                    v-model="filters.filterDate.fromDate"
                    @change="onSelectFilter"
                    locale="en"></date-picker>

                <a v-if="filters.filterDate.fromDate != null || filters.filterDate.toDate != null"
                   @click.prevent="clearDatesForm"
                   href="#" class="text-danger d-block">clear dates</a>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="DATE TO">
                <date-picker
                    popover
                    format="YYYY-MM-DD"
                    display-format="YYYY-MM-DD"
                    v-model="filters.filterDate.toDate"
                    @change="onSelectFilter"
                    locale="en"></date-picker>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="PRINT">
                <b-button @click="printOutput" variant="danger">{{ $t('printTitle') }}</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group
                  class="font-weight-bold"
                  label="SEARCH BY Best.-Nr.">
                <b-input v-model="searchOutput" placeholder="search..."></b-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div id="printOutput" class="table-responsive">
          <log-items :items="getOutputItems"></log-items>
        </div>
      </template>

    </b-modal>
    <!--END Outputs-->

    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'Stock'}"
            class="btn btn-primary btn-round">Back
        </b-link>
      </template>
    </navbar>
    <!--END Navbar-->

    <h2>{{ product.name }}</h2>
    <p>inventar: {{ product.amount | numFormat }}</p>

    <b-card>
      <b-button @click="deleteGroup" variant="danger">delete</b-button>
      <b-link
          class="btn btn-info"
          :to="{name:'StockAddGroup',params:{'groupid':this.$route.params.groupid}}">edit
      </b-link>
      <b-button v-b-modal.modal-1 variant="success">input</b-button>
      <b-button v-b-modal.modal-2 variant="warning">output</b-button>
    </b-card>
    <!--END Buttons-->

    <b-row v-if="products.length > 0">
      <b-col cols="12" md="3" v-for="(item,index) in products" :key="index">
        <b-card
            :title="item.product" :img-src="item.product_image">

          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
              inventar
              <span>{{ item.product_count }}</span>
            </b-list-group-item>

          </b-list-group>

          <div class="text-center">
            <b-button class="btn-round" variant="danger" @click="deleteProductStock(item.id)">delete</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!--END Products-->
  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import LogItems from "./Components/LogItems";
import FormStock from "./Components/formStock";
import {EventBus} from "../../Services/Eventbus/event-bus";


export default {
  name: "DetailsGroup",
  components: {FormStock, LogItems, Navbar},
  data() {
    return {
      products: [],
      product: null,
      logsOutput: [],
      logsInput: [],
      filters: {
        filterDate: {
          fromDate: null,
          toDate: null
        }
      },
      searchOutput: null,
    }
  },
  computed:{
    getOutputItems() {
      if (this.searchOutput === null) {
        return this.logsOutput;
      }

      return this.logsOutput.filter(item => {
        return String(item.orderTrackingNumber).includes(this.searchOutput)
      })
    },
  },
  methods: {
    printOutput() {
      this.$htmlToPaper('printOutput');
    },
    printInput() {
      this.$htmlToPaper('printInput');
    },
    clearDatesForm() {
      if (this.filters.filterDate.fromDate != null || this.filters.filterDate.toDate == null) {
        this.filters.filterDate.fromDate = null;
        this.filters.filterDate.toDate = null;
        this.logsInput = [];
        this.logsOutput = [];
        this.getDetails();
      }
    },
    onSelectFilter() {
      this.logsInput = [];
      this.logsOutput = [];
      this.getDetails();
    },
    getDetails() {
      if (this.$route.params.groupid && this.$route.params.groupid > 0) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'stock/group/show/' + this.$route.params.groupid, {
          dateFrom: this.filters.filterDate.fromDate,
          dateTo: this.filters.filterDate.toDate,
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.products = response.data.data.products;
                this.product = response.data.data.group;
                this.logsInput = response.data.data.logsInput;
                this.logsOutput = response.data.data.logsOutput;
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    deleteGroup() {
      if (this.$route.params.groupid && this.$route.params.groupid > 0) {
        if (confirm(this.$t('alertText'))) {
          this.$Progress.start();
          Http.get(Http.apiurlV2() + 'stock/group/delete/' + this.$route.params.groupid)
              .then(response => {
                this.$Progress.finish();
                if (response.data.status_code === Http.ok()) {
                  Notification.success(response.data.message);
                  this.$router.push({name: 'Stock'});
                }
              })
              .catch(error => {
                this.$Progress.finish();
              })
        }
      }
    },
    deleteProductStock(id) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'stock/delete/product/' + id)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                Notification.success(response.data.message);
                this.getDetails();
              } else {
                Notification.error(response.data.message);
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }
    },
  },
  created() {
    this.getDetails();
  },
  mounted() {
    let myThis = this;
    EventBus.$on('refreshData', function (payload) {
      if (payload === 'yes') {
        myThis.onSelectFilter()
      }
    });
  }
}
</script>

<style scoped>

</style>